// extracted by mini-css-extract-plugin
module.exports = {"bb-three-tile":"bb-three-tile__LFDgu"};